import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button, Form } from 'react-bootstrap';
import Select from 'react-select';
import { formatShortDate } from '../../../utils/helpers';
import ColumnToggle from '../../shared/ColumnToggle';
import { customSelectStyles, getTextBasedOnCat, resolveCategory, DEFAULT_FILTERS } from '../utils/reportHelpers';

export const Filterstop = ({ onDatachange, DataBefore, DataAfter, setLoading, onSearchChange, filterValues, setFilterValues, columnConfig, visibleColumns, onColumnsChange }) => {
    const [sitesDdl, setsitesDdl] = useState([]);
    const [roleDdl, setroleDdl] = useState([]);
    const [departmentDdl, setDepartmentDdl] = useState([]);
    const [ReportedDdl, setReportedDd] = useState([]);
    const [PeriodDdl, setPeriodDdlDdl] = useState([]);
    const [weekworkedDdl, setweekworkedDdl] = useState([]);
    const [CategoryDdl, setCategoryDdl] = useState([]);

    const filteringcolums = useMemo(() => ({ ...DEFAULT_FILTERS }), []);

    const updateFilterValues = (key, value) => {
        setFilterValues(prevState => ({
            ...prevState,
            [key]: value
        }));
    };

    useEffect(() => {
        if (DataAfter && DataAfter.length > 0) {
            setsitesDdl(Array.from(new Set(DataAfter.map(item => item.site))));
            setroleDdl(Array.from(new Set(DataAfter.map(item => item.role))));
            setReportedDd(Array.from(new Set(DataAfter.map(item => item.reportedToFinance))));
            setPeriodDdlDdl(Array.from(new Set(DataAfter.map(item => item.period))));
            setweekworkedDdl(Array.from(new Set(DataAfter.map(item => item.weekending))));
            setDepartmentDdl(Array.from(new Set(DataAfter.map(item => item.department))));
            setCategoryDdl(Array.from(new Set(
                DataAfter
                    .map(item => resolveCategory(item.cat, item.rowHighlightColour, item.credited))
                    .filter(cat => cat && cat !== '')
            )));
        }
    }, [DataAfter]);

    const handleClearFilters = () => {
        if (JSON.stringify(filteringcolums) !== JSON.stringify(filterValues)) {
            setLoading(true);
            onDatachange(DataBefore, true);
            setFilterValues(filteringcolums);
        }
    };

    const departmentOptions = departmentDdl.map(dept => ({ value: dept, label: dept }));
    const siteOptions = sitesDdl.sort().map(site => ({ value: site, label: site }));
    const roleOptions = roleDdl.sort().map(role => ({ value: role, label: role }));
    const reportedOptions = ReportedDdl
        .filter(dateStr => dateStr !== null)
        .sort((a, b) => a.localeCompare(b))
        .map(date => ({ value: date, label: formatShortDate(date) }));
    const periodOptions = PeriodDdl
        .slice()
        .sort((a, b) => b.localeCompare(a))
        .map(period => ({ value: period, label: period }));
    const weekOptions = weekworkedDdl
        .filter(dateStr => dateStr !== null)
        .sort((a, b) => b.localeCompare(a))
        .map(week => ({ value: week, label: formatShortDate(week) }));
    const categoryOptions = CategoryDdl.map(cat => ({ value: cat, label: getTextBasedOnCat(cat) }));

    return (
        <div className="reports-filters-container d-flex flex-wrap align-items-end my-2">

            <div className="filter-item">
                <label>Sites</label>
                <Select
                    value={filterValues.site ? { value: filterValues.site, label: filterValues.site } : null}
                    onChange={(selected) => updateFilterValues('site', selected ? selected.value : '')}
                    options={siteOptions}
                    placeholder="Select"
                    isClearable
                    isSearchable
                    classNamePrefix="react-select"
                    styles={customSelectStyles}
                />
            </div>

            <div className="filter-item">
                <label>Role</label>
                <Select
                    value={filterValues.role ? { value: filterValues.role, label: filterValues.role } : null}
                    onChange={(selected) => updateFilterValues('role', selected ? selected.value : '')}
                    options={roleOptions}
                    placeholder="Select"
                    isClearable
                    isSearchable
                    classNamePrefix="react-select"
                    styles={customSelectStyles}
                />
            </div>

            <div className="filter-item">
                <label>Reported</label>
                <Select
                    value={filterValues.reportedToFinance ? { value: filterValues.reportedToFinance, label: formatShortDate(filterValues.reportedToFinance) } : null}
                    onChange={(selected) => updateFilterValues('reportedToFinance', selected ? selected.value : '')}
                    options={reportedOptions}
                    placeholder="Select"
                    isClearable
                    isSearchable
                    classNamePrefix="react-select"
                    styles={customSelectStyles}
                />
            </div>

            <div className="filter-item">
                <label>Period</label>
                <Select
                    value={filterValues.period ? { value: filterValues.period, label: filterValues.period } : null}
                    onChange={(selected) => updateFilterValues('period', selected ? selected.value : '')}
                    options={periodOptions}
                    placeholder="Select"
                    isClearable
                    isSearchable
                    classNamePrefix="react-select"
                    styles={customSelectStyles}
                />
            </div>

            <div className="filter-item">
                <label>Week</label>
                <Select
                    value={filterValues.weekending ? { value: filterValues.weekending, label: formatShortDate(filterValues.weekending) } : null}
                    onChange={(selected) => updateFilterValues('weekending', selected ? selected.value : '')}
                    options={weekOptions}
                    placeholder="Select"
                    isClearable
                    isSearchable
                    classNamePrefix="react-select"
                    styles={customSelectStyles}
                />
            </div>

            <div className="filter-item">
                <label>Category</label>
                <Select
                    value={filterValues.cat ? { value: filterValues.cat, label: getTextBasedOnCat(filterValues.cat) } : null}
                    onChange={(selected) => updateFilterValues('cat', selected ? selected.value : '')}
                    options={categoryOptions}
                    placeholder="Select"
                    isClearable
                    isSearchable
                    classNamePrefix="react-select"
                    styles={customSelectStyles}
                />
            </div>

            <div className="filter-item search-filter-item">
                <label>Search</label>
                <input
                    type="text"
                    className="table-search form-control"
                    placeholder="Free search..."
                    onChange={onSearchChange}
                />
            </div>

            <div className="filter-actions d-flex align-items-end gap-2">
                <Button variant="clear-button" onClick={() => { handleClearFilters() }}>
                    Clear All
                </Button>
                {columnConfig && visibleColumns && onColumnsChange ? (
                    <ColumnToggle
                        columns={columnConfig}
                        visibleKeys={visibleColumns}
                        onChange={onColumnsChange}
                        footer={
                            <Form.Check
                                type="switch"
                                id="future-bookings"
                                checked={filterValues.future}
                                label="Future jobs"
                                onChange={() => updateFilterValues('future', !filterValues.future)}
                            />
                        }
                    />
                ) : (
                    <Form.Check
                        type="switch"
                        id="future-bookings"
                        checked={filterValues.future}
                        label="Future jobs"
                        onChange={() => updateFilterValues('future', !filterValues.future)}
                    />
                )}
            </div>
        </div>
    );
};

Filterstop.propTypes = {
    onDatachange: PropTypes.func.isRequired,
    DataBefore: PropTypes.array.isRequired,
    DataAfter: PropTypes.array.isRequired,
    setLoading: PropTypes.func.isRequired,
    onSearchChange: PropTypes.func.isRequired,
    filterValues: PropTypes.object.isRequired,
    setFilterValues: PropTypes.func.isRequired,
    columnConfig: PropTypes.array,
    visibleColumns: PropTypes.array,
    onColumnsChange: PropTypes.func,
};

export default Filterstop;
